import { gql } from 'graphql-request';

export const POA_SIGN = gql`
  mutation CorePOA($id: ID!, $signature: String!, $detachedSignature: String, $cert: String) {
    corePOA {
      sign(id: $id, signature: $signature, detachedSignature: $detachedSignature, cert: $cert)
    }
  }
`;
